import { Link } from "react-router-dom";
import { ArrowUpRight, Phone, Mail, MapPin, Linkedin, Facebook, Instagram } from "lucide-react";
import { NAV, COMPANY, LOGO } from "@/lib/data";

export const Footer = () => (
  <footer className="bg-[#0E1626] border-t border-[#1E293B] relative z-10 text-slate-300" data-testid="site-footer">
    <div className="max-w-[1500px] mx-auto px-5 md:px-10 py-20">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3 mb-6">
            <img src={LOGO} alt="JM Mevada" className="h-14 w-14 object-contain bg-white rounded-sm p-1" />
            <div>
              <div className="font-display font-extrabold text-xl tracking-tight text-white">JM MEVADA</div>
              <div className="font-mono text-[10px] tracking-[0.2em] text-slate-500 uppercase">Pattern Works</div>
            </div>
          </div>
          <p className="text-slate-400 text-lg font-light max-w-md leading-relaxed">
            55+ Years of Pattern Making & Manufacturing Experience. A family legacy building precision industrial patterns for foundries across India.
          </p>
          <div className="flex gap-3 mt-8">
            {[Linkedin, Facebook, Instagram].map((Icon, i) => (
              <a key={i} href="#" data-testid={`footer-social-${i}`} className="w-11 h-11 flex items-center justify-center border border-[#2A3546] text-slate-400 hover:border-slate-300 hover:text-white transition-colors duration-300">
                <Icon size={17} />
              </a>
            ))}
          </div>
        </div>

        <div className="lg:col-span-3">
          <div className="overline mb-6 !text-[#60A5FA]">Quick Links</div>
          <div className="flex flex-col gap-3">
            {NAV.map((n) => (
              <Link key={n.to} to={n.to} className="text-slate-400 hover:text-white transition-colors duration-300 w-fit">{n.label}</Link>
            ))}
          </div>
        </div>

        <div className="lg:col-span-4">
          <div className="overline mb-6 !text-[#60A5FA]">Contact Information</div>
          <div className="flex flex-col gap-4 text-slate-400">
            <a href={`tel:${COMPANY.phoneRaw}`} className="flex items-start gap-3 hover:text-white transition-colors duration-300"><Phone size={17} className="mt-1 text-[#60A5FA]" /> {COMPANY.phone}</a>
            <a href={`mailto:${COMPANY.email}`} className="flex items-start gap-3 hover:text-white transition-colors duration-300"><Mail size={17} className="mt-1 text-[#60A5FA]" /> {COMPANY.email}</a>
            <span className="flex items-start gap-3"><MapPin size={17} className="mt-1 text-[#60A5FA]" /> {COMPANY.address}</span>
          </div>
          <Link to="/enquiry" data-testid="footer-request-quote" className="btn-primary mt-8 !bg-white !text-[#0E1626] hover:!bg-[#1D4ED8] hover:!text-white">
            Request A Quote <ArrowUpRight size={16} />
          </Link>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-[#1E293B] flex flex-col md:flex-row justify-between gap-4 text-slate-500 text-sm font-mono">
        <span>© {new Date().getFullYear()} {COMPANY.name}. All rights reserved.</span>
        <span>Established 1969 · Ahmedabad, Gujarat, India</span>
      </div>
    </div>
  </footer>
);
